export enum EntityType {
  qb = 'QB',
  spm = 'SPM'
}
